'use client';

import useAnalyticsTracking from "@/components/common/analytics/use_analytics_tracking";
import useOpenAiAdsPixel from "@/components/common/analytics/use_openai_ads_pixel";
import { useSession } from "next-auth/react";
import { useContext, useEffect } from "react";
import AuthContext from "@/providers/auth-context";

/**
 * Component to track Google/Facebook registration via GTM
 * Monitors session changes and sends GTM event when new user registers via social login
 */
export default function SocialAuthTracker() {
    const { data: session, status } = useSession();
    const { userData } = useContext(AuthContext);
    const { trackEvent: trackSocialRegistration } = useAnalyticsTracking('socialAuthTracking');
    const { measure: measureOpenAiAds } = useOpenAiAdsPixel();

    useEffect(() => {
        // ChatGPT Ads: saját kulccsal, mert marketing (nem analytics) hozzájárulás kell hozzá
        const openAiTrackedKey = `tracked_openai_registration_${userData?.id}`;
        if (
            typeof window !== 'undefined'
            && status === "authenticated"
            && session?.user?.isNewUser
            && session.user.registrationMethod
            && userData?.id > 0
            && !sessionStorage.getItem(openAiTrackedKey)
        ) {
            const wasMeasured = measureOpenAiAds('registration_completed');
            if (wasMeasured) sessionStorage.setItem(openAiTrackedKey, 'true');
        }

        // Check if we already tracked this registration
        const trackedKey = `tracked_registration_${userData?.id}`;
        if (typeof window !== 'undefined' && sessionStorage.getItem(trackedKey)) {
            return;
        }

        // Check if authenticated and we have user data
        if (status === "authenticated" && session?.user && userData?.id > 0) {
            // Check if this is a new user registration via social login
            if (session.user.isNewUser && session.user.registrationMethod) {
                const wasTracked = trackSocialRegistration('user_registration_success', {
                    registered_user_id: userData.id,
                    registration_method: session.user.registrationMethod
                });

                if (wasTracked) {
                    // Mark as tracked for this session
                    sessionStorage.setItem(trackedKey, 'true');
                }
            }
        }
    }, [status, session, trackSocialRegistration, measureOpenAiAds, userData]);

    // This is a tracking-only component, renders nothing
    return null;
}
